import $ from 'jquery';

const ignoredEls = [
  'data-mobile-nav',
  'data-site-navigation',
];

function isIgnored(element) {
  // Disallow if element is a <script>
  if (element.tagName === 'SCRIPT') {
    return true;
  }

  // Allow if element has no attributes
  if (element.attributes.length === 0) {
    return false;
  }

  // Check if any attributes match to the ignore list
  return [].slice.call(element.attributes).some((attr) => {
    return ignoredEls.indexOf(attr.name) !== -1;
  });
}

/**
 * Get the offset of the header
 *
 * @param {HTMLElement} header
 * @param {Boolean} withAnnouncementBar
 * @returns {number}
 */
export default function getHeaderOffset(header, withAnnouncementBar = false) {
  const headerEls = header.childNodes;
  const isSticky = header.querySelector('[data-site-header-sticky]');
  const { pageYOffset } = window;
  let offset = 0;

  if (isSticky) {
    for (let i = 0; i < headerEls.length; i++) {
      if (headerEls[i] instanceof HTMLElement && !isIgnored(headerEls[i])) {
        offset += headerEls[i].getBoundingClientRect().height;
      }
    }

    if ($(header).hasClass('site-header-sticky--open') || pageYOffset === 0) {
      offset += header.querySelector('[data-site-navigation]').getBoundingClientRect().height;
    }
  } else {
    // If is not sticky header, then DOM can be trusted to return values
    const { bottom } = header.getBoundingClientRect();

    offset = bottom > 0 ? bottom : 0;
  }

  if (withAnnouncementBar) {
    offset += parseInt(header.style.top, 10) || 0;
  }

  return offset;
}
